import { Dispatch, ReactNode } from 'react';
import { Merchant, Registration, User } from '@stax-core/types-omni';

export interface AuthContextProps {
  children: ReactNode;
  initialState?: AuthState;
}
interface MerchantWithRegistration extends Merchant {
  registration?: Registration | null;
}
export interface AuthDatum {
  merchant: MerchantWithRegistration | null;
  token: string;
  user: User;
}

export interface Auth {
  data: AuthDatum[];
  index: number;
  merchant: Merchant | null;
  token: string;
  user: User;
  brand: string;
}

export interface AuthState {
  auth: Auth | null;
  authToken: string | null;
  effect: { type: AuthEffectType; payload?: Auth | null } | null;
  // `notauthed` if there is no auth or auth token
  // `authed.stale` if there is auth but it was hydrated from localStorage
  // `authed.fresh` if there is auth and it was fetched during this run of the app
  status: 'notauthed' | 'authed.stale' | 'authed.fresh';
}

export enum AuthActionType {
  REMOVE_AUTH = 'REMOVE_AUTH', // log out
  UPDATE_AUTH = 'UPDATE_AUTH', // log in or update
  UPDATE_AUTH_INDEX = 'UPDATE_AUTH_INDEX', // switch merchant
  UPDATE_AUTH_USER = 'UPDATE_AUTH_USER',
  UPDATE_AUTH_MERCHANT = 'UPDATE_AUTH_MERCHANT',
}

export enum AuthEffectType {
  REMOVE_AUTH = 'REMOVE_AUTH', // log out
  UPDATE_AUTH = 'UPDATE_AUTH', // log in or update
  UPDATE_AUTH_INDEX = 'UPDATE_AUTH_INDEX', // switch merchant
  UPDATE_AUTH_USER = 'UPDATE_AUTH_USER',
  UPDATE_AUTH_MERCHANT = 'UPDATE_AUTH_MERCHANT',
}

export type AuthAction = { type: AuthActionType; payload?: any };

export interface AuthContext {
  state: AuthState;
  dispatch: Dispatch<AuthAction>;
}
